import Eyebrow from '../../../../components/blackrock/advisor-center/eyebrow/Eyebrow.tsx';
import { ArticleDetail } from '../../../../components/blackrock/advisor-center/article-detail/ArticleDetail.tsx';
import { ArticleHeaderImage } from './components/ArticleHeaderImage.tsx';
import Style from '../../../../components/blackrock/advisor-center/style/Style.tsx';
import { SeriesItemData } from '../../../../components/blackrock/advisor-center/cards/series-item-card/SeriesItemCardProps.ts';
import {
	Brand,
	SaveConfig,
} from '../../../../components/blackrock/advisor-center/save/SaveButtonProps.ts';
import { useState } from 'react';
import { useSaveForSingleSeriesItem } from '../../../../components/blackrock/advisor-center/save/hooks/useSaveForSingleSeriesItem.ts';
import SaveButton from '../../../../components/blackrock/advisor-center/save/SaveButton.tsx';

import './ArticleHeader.scss';

export type ArticleHeaderProps = {
	itemData: ArticleHeaderItemData;
	saveConfig: SaveConfig;
};

export type ArticleHeaderItemData = SeriesItemData & {
	itemTypeIcon?: string;
	imageAlt?: string;
	imageVerticalPosition?: string;
	background: BackgroundColors;
	isIsharesVariant: boolean;
};

export type BackgroundColors =
	| 'white'
	| 'green'
	| 'blue'
	| 'purple'
	| 'yellow'
	| 'pink'
	| 'gray';

/**
 * Article Header components for the CMS.
 * It can show the title, description, image of an article.
 */
const ArticleHeader: React.FC<ArticleHeaderProps> = ({
	itemData = {} as ArticleHeaderItemData,
	saveConfig,
}) => {
	const [item, setItem] = useState<ArticleHeaderItemData>(itemData);

	const onSaveButtonClick = useSaveForSingleSeriesItem<ArticleHeaderItemData>(
		setItem,
		saveConfig
	);

	return (
		<Style className="blk-ac-article-header">
			<span className="card-link" tabIndex={0}>
				<div
					className={['title-and-image', !itemData.imagePath && 'no-image']
						.join(' ')
						.trim()}
				>
					<div className="article-header-title">
						<Eyebrow
							icon={itemData.itemTypeIcon || 'fal fa-newspaper'}
							// eslint-disable-next-line @typescript-eslint/ban-ts-comment
							// @ts-ignore
							tag={itemData.eyebrowTag}
						/>
						<div className="content">
							<h1 className="content-title line-clamp blk-ac-heading-xl-fixed">
								{truncateString(itemData.contentTitle, 70)}
							</h1>
						</div>
					</div>
					{itemData.imagePath && (
						<ArticleHeaderImage
							// eslint-disable-next-line @typescript-eslint/ban-ts-comment
							// @ts-ignore
							imageAlt={itemData.imageAlt}
							imagePath={itemData.imagePath}
							// eslint-disable-next-line @typescript-eslint/ban-ts-comment
							// @ts-ignore
							imageVerticalPosition={itemData.imageVerticalPosition}
							isIsharesVariant={itemData.isIsharesVariant}
						/>
					)}
				</div>
				<div
					className={[
						'item-details-container',
						item.savable && !item.publicationDate && !item.authors?.length
							? 'only-save-button'
							: '',
					]
						.join(' ')
						.trim()}
				>
					{/* // eslint-disable-next-line @typescript-eslint/ban-ts-comment //
					@ts-ignore */}
					<ArticleDetail
						publicationDate={item.publicationDate}
						authors={item?.authors || []}
					/>
					{item.savable && (
						<SaveButton
							isSaved={item.saved}
							saveConfig={saveConfig}
							item={item}
							parentIsHovered={true}
							parentIsFocusVisible={true}
							onClick={onSaveButtonClick}
							brand={
								itemData.isIsharesVariant ? Brand.ISHARES : Brand.BLACKROCK
							}
						/>
					)}
				</div>
			</span>
		</Style>
	);
};

export default ArticleHeader;

export const truncateString = (str: string, maxLength: number): string => {
	return str.length > maxLength ? `${str.slice(0, maxLength - 3)}...` : str;
};
